import Services from "services"

class PermintaanPerubahanDataApi {
  async getList(params) {
    const fetch = await Services.get("/hrdu/permintaan_perubahan_data/page", {
      params,
    })
    return fetch.data
  }

  getSingle(params) {
    return Services.get("/hrdu/permintaan_perubahan_data/single", { params })
  }

  generateNumber(params) {
    return Services.get("/hrdu/permintaan_perubahan_data/no_baru", { params })
  }

  getHakAkses(params) {
    return Services.get("/hrdu/hak_akses", { params })
  }

  async getDropdownUrgensi() {
    return [
      { label: "Sangat Tinggi", value: "Sangat Tinggi" },
      { label: "Tinggi", value: "Tinggi" },
      { label: "Sedang", value: "Sedang" },
      { label: "Rendah", value: "Rendah" },
      { label: "Sangat Rendah", value: "Sangat Rendah" }
    ]
  }

  async getDropdownStatusApproval() {
    return [
      { label: "PENDING", value: "PEN" },
      {
        value: "VER",
        label: "VERIFIED",
      },
      {
        value: "APP",
        label: "APPROVED",
      },
      {
        value: "REV",
        label: "REVISI",
      },
      {
        value: "REJ",
        label: "REJECT",
      },
    ]
  }

  create(data) {
    return Services.post("/hrdu/permintaan_perubahan_data", data)
  }

  update(data) {
    return Services.put("/hrdu/permintaan_perubahan_data", data)
  }

  upload(data) {
    return Services.post("/hrdu/upload/permintaan_perubahan_data_multiple", data)
  }
}

export default new PermintaanPerubahanDataApi()
